import { render } from "./famousCourseLookVideo.vue?vue&type=template&id=02efb96e&scoped=true"
import script from "./famousCourseLookVideo.vue?vue&type=script&lang=js"
export * from "./famousCourseLookVideo.vue?vue&type=script&lang=js"

import "./famousCourseLookVideo.vue?vue&type=style&index=0&id=02efb96e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02efb96e"]])

export default __exports__